import type {BNUserConferencesAddFeedbackParams} from '../../../api/types/bnrks/methods';
import type {CoreUserConferencesAddFeedbackParams} from '../../../api/types/core/methods';
import type {RateConferenceConfig} from '../../../modules/conference-rating/types';

import {apiRequest} from '../../../api/utils/apiRequest';
import {logger} from '../../../utils/logger';

type Config = Omit<RateConferenceConfig, 'isB2b'> & {
  comment?: string;
  ratings?: {[key in RatingKey]?: number};
};

type RatingKey =
  | 'audio_quality'
  | 'client_not_show'
  | 'coaching_quality'
  | 'completed_successfully'
  | 'video_quality';

export async function conferenceAddFeedback({
  comment,
  id,
  ratings,
  role,
  type,
}: Config) {
  logger.event('session_rate_submit', {
    role,
    session_type: type,
    with_comment: comment?.length ? 'yes' : 'no',
  });

  await apiRequest<
    BNUserConferencesAddFeedbackParams | CoreUserConferencesAddFeedbackParams
  >({
    method: 'user.conferences.add_feedback',
    params: {comment, conference_id: id, ...ratings},
  });
}
